import React from 'react';
import buttonImage from '../buttonimage.webp'; // Import button image
import backgroundImage from '../background.webp'; // Import background image
import cardBackgroundImage from '../cardbackground.webp'; // Import card background image

function Trauma({ goBack, goHome, handleSaveProgress }) {
    const handleSave = async () => {
        if (typeof handleSaveProgress === 'function') {
            await handleSaveProgress('trauma', null, false);
            alert('Session progress has been saved successfully!');
        }
    };

    return (
        <div style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '16px',
        }}>
            {/* Title */}
            <h3 style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'black',
                marginBottom: '32px',
            }}>
                Trauma
            </h3>

            {/* Session Helper Cards Row */}
            <div
                className="trauma-session-helper-row"
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '16px',
                }}
            >
                {/* Left Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>• Trauma can be about what did or did not happen</div>
                        <div>• What constitutes trauma is an individual experience because each person has unique energy to experience life with and through</div>
                        <div>• Trauma is an inability to process an experience</div>
                        <div>• It is self loving to develop a way to cope with trauma until we can process it</div>
                        <div>• Seek help when you need help processing </div>
                        <div>• Sometimes the trauma is layered and effecting us in many ways</div>
                    </div>
                </div>
                {/* Right Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>1. Have you identified an unprocessed trauma?</div>
                        <div>2. Do you feel like it would or does mean you are lesser if you were traumatized, or because you are?</div>
                        <div>3. Have you had difficulty understanding someone else who is suffering with trauma?</div>
                        <div>4. Do you feel safe to proceed with self reflecting on your trauma?</div>
                        <div>5. Are there some Traumas you feel cannot be healed?</div>
                        <div>6. What small, intentional step can you take today to create a sense of safety and compassion for yourself as you process and heal from your past experiences? </div>
                    </div>
                </div>
            </div>

            {/* Cards */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
            }}>
                {/* Card 1 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        Years ago it used to be said that trauma cannot be healed. The label PTSD used to signify a damaged person who was bound to repeat the traumatic experience they had in the past. Today we know that is not true.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        We understand much more about what causes a trauma to be anchored for us to experience on repeat and therefore what needs to happen in order to release ourselves. This is a unique and personalized experience for each of us.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        It is important that when we delve into this topic and this kind of self-reflection that we are discerning enough to know:
                    </p>
                    <ul style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'left',
                        lineHeight: '1.5',
                        marginLeft: '16px',
                        marginBottom: '16px',
                    }}>
                        <li>What we can handle and what we are ready to address.</li>
                        <li>The resources available to help us through it.</li>
                    </ul>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        Basically, we need to be able to promise and keep our promise to not hurt ourselves or anyone else through this process. If you know you have a trigger that you cannot handle on your own, it is your responsibility to assure that you do not engage in this self-reflection without the support you need.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        This is about taking responsibility for ourselves and caretaking ourselves first. That means we must assess our capabilities honestly. If we are starting from a place of having been victimized and feeling like life is not fair, we need to be very gentle with ourselves as we address these topics. The best starting place is to begin with addressing what is directly in front of us. In my experience sometimes it felt like a jenga tower when I started to address one thing many more got my attention too.  It is important to just follow through on each thing, but take the time you need. 
                    </p>
                </div>

                {/* Card 2 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        What constitutes trauma is different for different people. Years ago in my journey of self-reflection, I realized that it is my opinion that what was being referred to as PTSD was actually an amplified example of how we work as humans. It did not have to be a car accident or a war that anchored in an unprocessed feeling or fear—it could just be life experiences.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        I realized that I was experiencing a series of programmed responses that were all there to help me avoid certain feelings and experiences that had previously overwhelmed me, not made sense to me, or that I had false conclusions as a result of! I realized that I was only ever reacting to life and there was no room for my response.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        The reason was that I had so many coping mechanisms and trigger points that my whole existence consisted of playing them out over and over again. I was miserable! I did not feel in control of any aspect of my life. I felt like a victim overall, believing that I was not enough and there was not enough, and I was mostly dissociated through each day.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        I had a trigger around just about everything in my day, from brushing my teeth to going to bed. The reason was because I had grown up in a household with violence. I was quite overwhelmed when these experiences happened, and as a result, there was a lock created in my experience for this energy to be thrown into the future for me to experience again later when I might be more equipped to process it and remain present with it.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        Because I was in the lack mindset with low self-worth and believing I was a victim in life, when those triggers activated me in the feeling again (like a PTSD trigger), I was not in a position to resolve any of those misunderstandings and overwhelm for many years. I was just compounding the damage to my self-esteem and my life as the consequences of living those triggers again and again caused more and more damage to my ability to cope with the chaos and overwhelm I was always in.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        As I look back to describe it now, I am amazed at the progress I have made with the tools I am sharing in this app. I know the feeling of hopelessness and suicidal ideation. I know the experience of turning to counselors that could not help me and medications that never solved the issues.
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        textAlign: 'center',
                        lineHeight: '1.5',
                        marginBottom: '16px',
                    }}>
                        I understand what it is like to always feel alone and never feel like you can have what you need. The feelings I had about wanting to be loved and to feel safe in the world constantly haunted me, and my coping mechanisms were not healthy either. Today I can say that I am so thankful that my coping mechanisms crumbled because it is what allowed me to eventually start building myself back up again.
                    </p>
                </div>

                {/* Card 3 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        Traumatizing experiences can cause different people to use different coping mechanisms.  Some of the ways we cope is through what is taught to us and other times we use one of the commonly used coping strategies of humans.  Trauma can even cause some people to regress back to an earlier age.  I do not have any experience with regression but I know that some people will have experienced it.  
                    </p>
                </div>
            </div>

            {/* Navigation Buttons */}
            <div
                className="trauma-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px',
                    marginBottom: '16px',
                }}
            >
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goBack}>Back</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goHome}>Home</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={handleSave}>Save</button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .trauma-nav-btn-row {
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Trauma;
